import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';


function ResetPassSendLink() {
  const pagination = useRef();
  const selectRef = useRef();
  const [searchemail, setSearchemail] = useState('');
  const [perPage, setPerpage] = useState('');
  const [selectedOption, setSelectedOption] = useState([]);
  const [pendingEmail, setPendingEmail] = useState([]);
  const [emplist, setEmplist] = useState([]);
  const [totalitem, setTotalitem] = useState('');
  const [error, setError] = useState("");
  const [searchbytext, setSearchbytext] = useState('');
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  const handleChange = (event) => {
    // const selected = Array.from(event.target.selectedOption, (option) => option.value);
    //setSelectedOption(selected);
  };
  const setPage = ({ selected }) => {
    getuserlist(selected + 1);
  }
  useEffect(() => {   
    getuserlist()
  }, []);

  const getuserlist = async (pagenumber) => {

    const response = await fetch(SERVER_URL + `api/employee/rest/employee-password?query=${searchemail}&&page=${pagenumber == 'undefined' ? 1 : pagenumber}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      })
      .then(res => res.json())
      .then(data => {
        // console.log("data.Emptotal[0].Total");
        // console.log(data.Emptotal[0].Total);
        setEmplist(data.users)
        setTotalitem(data.Emptotal[0].Total);
        setPerpage(data.limit)
      });
  }
 
  const [checkList, setCheckList] = useState([
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false }
  ]);

  
  const [countccheckbox, setCountccheckbox] = useState(0)
  const [allcheck, setAllcheck] = useState(false)
  const [resetbtn, setResetbtn] = useState(false)
  const [checkUserIdList, setCheckUserIdList] = useState([])
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const handleCheckboxSingle = (event) => {
    var count = countccheckbox;
    checkList[event.target.name].checked = !checkList[event.target.name].checked;
    setCheckList([...checkList]);


    if (checkList[event.target.name].checked == true) {
      count = parseInt(count) + 1
      setCountccheckbox(count)
      addItem(event.target.value)

    }
    if (checkList[event.target.name].checked == false) {
      count = parseInt(count) - 1
      setCountccheckbox(count)
      removeItem(event.target.value)
    }
    setResetbtn(false)
    if (count > 0) {
      setResetbtn(true)
    }
    if (count == 10) {
      setAllcheck(true)
      setResetbtn(true)
    } else {
      setAllcheck(false)
    }

  }
  const handleAllcheckbox = () => {

    var count = countccheckbox;

    var allchecknox = !allcheck
    if (allchecknox == true && countccheckbox > 0) {
      for (const item of checkList) {
        item.checked = allchecknox;
      }
      count = 10
      setCountccheckbox(10)
      checkAllitemAdd()
    }
    if (allchecknox == true) {
      for (const item of checkList) {
        item.checked = allchecknox;
      }
      count = 10
      setCountccheckbox(10)
      checkAllitemAdd()
    } else {
      for (const item of checkList) {
        item.checked = allchecknox;
      }
      count = 0
      setCountccheckbox(0)
      checkAllitemRemove()
    }
    setCheckList([...checkList]);
    setAllcheck(allchecknox)
    setResetbtn(false)
    if (count > 0) {
      setResetbtn(true)
    }

  }
  const handleSendResetPassLink = () => {
    const response = fetch(SERVER_URL + `api/common/bulk-mail`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
          id: checkUserIdList
        }),
      }).then(res => res.json())
      .then(data => {
        if (data.status == true) {
          setMsg('Reset password link send successfully')
          setErr('red')
          setResetbtn(false)
          checkAllitemRemove()

          setAllcheck(false)

          setCheckList([{ checked: false },
          { checked: false },
          { checked: false },
          { checked: false },
          { checked: false },
          { checked: false },
          { checked: false },
          { checked: false },
          { checked: false },
          { checked: false }])

          setTimeout(function () {
            getuserlist()
            setMsg('')
          }, 1000);
        }
        // console.log(data)
      })


  }

  const removeItem = (val) => {
    checkUserIdList.map((item, ind) => {
      if (item == val) {
        checkUserIdList.splice(ind, 1)
        setCheckUserIdList([...checkUserIdList])
      }
    })
  }
  const addItem = (val) => {
    setCheckUserIdList(checkUserIdList => [...checkUserIdList, val]);
  }
  const checkAllitemAdd = () => {
    setCheckUserIdList([]);
    emplist.map((item, ind) => {
      setCheckUserIdList(checkUserIdList => [...checkUserIdList, item.id]);
    })
  }
  const checkAllitemRemove = () => {
    setCheckUserIdList([]);
  }

  const handleSearchbytext = (text) => {
    setSearchbytext(text)

    if (text.length > 2) {
      setSearchemail(text)
      getuserlist()
    } else {
      setSearchemail('')
      getuserlist()
    }

  }
  return (
    <>
      <div className="page-header">
        <h1>Employee</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li className="current">
            <span>/</span> Reset Password
          </li>
        </ul>
      </div>
      <div className="row_bg">
      <div className="dash_white_box2 mb20 p20">
        <div className="dash_white_box_ttl">Search</div>
        <div className="row mb10">
          <div className="col-lg-3 col-md-6 pr07">
            <label className="form-label">Employee Name / Code</label>
            <input type="text" className="form-control" onChange={(e) => { handleSearchbytext(e.target.value) }} value={searchbytext} autoComplete='none' placeholder='Search by name' />
          </div>          
        </div>
      </div>
      <div className="row mb30">
        <div className="col-md-12">
          <span style={{ display: err }} >{msg}</span>
          <button className="btn_5 mb12" onClick={handleSendResetPassLink} style={{ display: resetbtn ? 'block' : 'none' }} href="/addemployee">Send Mail</button>
          <table className="table_style_1">
            <thead>
              <tr>
                <th style={{ width: "70px" }}><input type='checkbox' id='checlAll' checked={allcheck} onChange={handleAllcheckbox} /> All</th>
                <th>Employee Code</th>
                <th>Employee Name</th>
                <th>Department </th>
                <th>Designation	</th>
                <th>Employee Type</th>
                <th>Contact</th>
                {/* <th style={{ width: "140px" }}>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {emplist?.map((item, ind) => (
                <tr key={ind}>
                  <td><input name={ind} type='checkbox' checked={checkList[ind].checked} value={item.id} onChange={handleCheckboxSingle} className='resetlinkcheckbox' /></td>
                  <td>{item.user_code ? item.user_code : ''}</td>
                  <td><span className="avatar_icon">{item.name ? item.name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>{item.name}</td>
                  <td>{item.dept_name}</td>
                  <td>{item.role_name}</td>
                  <td>Inhouse</td>
                  <td>{item.contact_no ? item.contact_no : ''}</td>
                  {/* <td>
                    <button className="btn_5 mr03">View</button>
                    <Link to={`/editemployee?id=${+item.id}`} className="btn_7">Edit</Link>
                  </td> */}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr><td colSpan="8" >
                <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                <ReactPaginate
                  ref={pagination}
                  pageCount={Math.ceil(totalitem / perPage)}
                  pageRangeDisplayed={4}
                  marginPagesDisplayed={1}
                  onPageChange={setPage}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageLinkClassName="page-link"
                  breakLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  pageClassName="page-item"
                  breakClassName="page-item"
                  nextClassName="page-item"
                  previousClassName="page-item"
                  previousLabel={<>&laquo;</>}
                  nextLabel={<>&raquo;</>}
                />
              </td></tr>
            </tfoot>
          </table>
        </div>
      </div></div>
    </>

  );
}

export default ResetPassSendLink;